import React, { useState } from "react";
import { auth, db } from "../../db/firebaseConfig";
import { signInWithEmailAndPassword, sendPasswordResetEmail } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";

export default function Login({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Iniciar sesión
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      // Comprobar si el email está verificado
      if (!user.emailVerified) {
        alert("Debes verificar tu correo antes de iniciar sesión.");
        setLoading(false);
        return;
      }

      // Traer información adicional del usuario desde Firestore
      const userDoc = await getDoc(doc(db, "usuarios", user.uid));
      const userData = userDoc.exists() 
        ? { uid: user.uid, ...userDoc.data() } 
        : { uid: user.uid, email: user.email, rol: "cliente" };

      // Informar al componente padre
      onLogin(userData);

      // Limpiar formulario
      setEmail("");
      setPassword("");
    } catch (error) {
      console.error(error.message);
      alert(error.message);
    }

    setLoading(false);
  };

  const handleForgotPassword = async () => {
    if (!email) {
      alert("Ingresá tu email primero");
      return;
    }
    try {
      await sendPasswordResetEmail(auth, email);
      alert("Se envió un enlace de recuperación a tu correo.");
    } catch (error) {
      console.error(error.message);
      alert(error.message);
    }
  };

  return (
    <div>
      <h2 className="text-2xl font-bold mb-4">Iniciar sesión</h2>
      <form onSubmit={handleLogin} className="flex flex-col gap-4">
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="border p-2 rounded"
          required
        />
        <input
          type="password"
          placeholder="Contraseña"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="border p-2 rounded"
          required
        />
        <button
          type="submit"
          disabled={loading}
          className="bg-green-500 text-white py-2 rounded"
        >
          {loading ? "Ingresando..." : "Iniciar sesión"}
        </button>
      </form>

      <button
        type="button"
        onClick={handleForgotPassword}
        className="text-blue-600 underline mt-2"
      >
        ¿Olvidaste tu contraseña?
      </button>
    </div>
  );
}
